import { render, staticRenderFns } from "./BillStage.vue?vue&type=template&id=55a038cc&scoped=true"
import script from "./BillStage.vue?vue&type=script&lang=js"
export * from "./BillStage.vue?vue&type=script&lang=js"
import style0 from "./BillStage.vue?vue&type=style&index=0&id=55a038cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a038cc",
  null
  
)

export default component.exports